import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { EgStepperComponent } from '../../shared/components/eg-stepper/eg-stepper.component';
import { SharedModule } from '../../shared/shared.module';
import { NgStepperModule } from 'angular-ng-stepper';
import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { EgFormComponent } from '../../shared/components/eg-form/eg-form.component';
import { ApplicationFormService } from '../../service/application-form.service';
import { CommonModule, formatDate } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DataSharingService } from '../../shared/services/data-sharing.service';
import { Subscription } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ValidatorFn, Validators,} from '@angular/forms';
import { IValidator } from '../../shared/interface/validator';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedApplicantService } from '../../shared/services/shared-applicant.service';
import { ApplicantService } from '../../service/applicant.service';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { EgDialogComponent } from '../../shared/components/eg-dialog/eg-dialog.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateTime } from 'luxon';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS , MAT_LUXON_DATE_FORMATS} from '@angular/material-luxon-adapter';
import { onNextSectionUtil, populateFormFieldsUtil, registerDateAndAddressValueChangeHandlers, registerValueChangeHandlers, setNonMedicaidDatesUtil, validateMedicaidDateUtil, validateNonMedicaidDateUtil } from './application-form.util';
import { calculateAge } from '../../shared/utils/date.util';
import { environment } from '../../../environments/environment';
import { UserManagementService } from '../../service/user-management.service';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatCardContent, MatCardModule } from '@angular/material/card';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { RockJSONData } from '../../shared/constant/rock-data.contants';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';

import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'application-form',
  standalone: true,
  imports: [
    EgStepperComponent,
    SharedModule,
    NgStepperModule,
    CdkStepperModule,
    EgFormComponent,
    CommonModule,
    NgbRatingModule,
    MatDialogModule,
    FormsModule
  ],
  templateUrl: './application-form.component.html',
  styleUrl: './application-form.component.scss',
  providers: [
    { provide: CdkStepper },
    { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
    { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
})
export class ApplicationFormComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper', { static: true }) stepper: any;
  @ViewChild(EgFormComponent) formComponent!: EgFormComponent;
  @ViewChild('cdkStepper', { static: true }) cdkStepper: any;
  public dynFormGroup: FormGroup = this.formBuilder.group({});
  subForm: any;
  applicantId: string | null = null;
  formData: any;
  dynForm: any;
  subscription!: Subscription;
  formJSON: any;
  currentFormIndex: any;
  applicationId!: any;
  saveButtonLabel = 'Next';
  isFormSubmitted = false;
  showModal = false;
  dataCompleted = false;
  @ViewChild(EgStepperComponent) stepperCompnent!: EgStepperComponent;
  isLoading: boolean = false;
  isDeterminationLoading: boolean = false;
  isReviewLoading : boolean = false;
  isView : boolean = false;
  fromDate: any;
  toDate: any;
  fromNonMedicaidDate: any;
  toNonMedicaidDate: any;
  private userId: string | null = null;
  agencyId: any = null;
  createdDate: any;
  lastModifiedDate: any;
  createdBy: any;
  lastModifiedBy: any;
  goToReview: boolean = false;
  isEligibilityAutoDetermined: boolean = false;
  formLength: number = 0;
  reviewIndex: number = 0;
  printIndex: number = -1;
  formStyles: any;
  envMeckAgencyId: any = null;
  renewalParentId: any;

  constructor(
    private readonly sharedApplicantService: SharedApplicantService,
    private readonly applicantService: ApplicantService,
    private readonly applicationFormService: ApplicationFormService,
    private readonly dataSharing: DataSharingService,
    private readonly formBuilder: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly userManagementService: UserManagementService,
    private readonly userService: UserService,
  ) {
    this.dynFormGroup = this.formBuilder.group({
      FirstName: [''],
      MiddleName: [''],
      LastName: [''],
      DateOfBirth: [''],
      CurrentAge: [''],
      Gender: [''],
      ContactPrimaryPhoneNumber: [''],
      ContactAlternatePhoneNumber: [''],
      EmailAddress: [''],
      HomeAddress: [''],
      HomeCity: [''],
      HomeState: [''],
      HomeZipCode: [''],
      MailingAddress: [''],
      MailingCity: [''],
      MailingState: [''],
      MailingZipCode: [''],
      PersonalID: [''],
      medicare: [''],
      medicaid: [''],
      emergency_state: ['']
    });
    this.isView = this.router.getCurrentNavigation()?.extras.state?.['previewForm'];
    this.isEligibilityAutoDetermined = sessionStorage.getItem('isEligibilityAutoDetermined') == 'true' ? true : false;
  }

  feedback : any;
  rating : any;
  isValidateDate = false;
  isValidateNonMedicaidDate = false;
  ngOnInit(): void {
    this.isLoading = false;
    this.printOptionSelected = 'no';
    this.feedback = '';
    this.rating = '';
    this.route.queryParams.subscribe((params) => {
      this.applicationId = params['id'];
      if (this.applicationId) {
        localStorage.setItem('applicationId', this.applicationId.toString());
      } else {
        localStorage.clear();
      }
    });
    this.sharedApplicantService.applicantId$.subscribe((id) => {
      this.applicantId = id;
      if (this.applicantId) {
        this.getApplicantData(Number(this.applicantId));
      }
    });

    this.getFormData();
    this.dataSharing.getFormData.subscribe((data) => {
      let age = this.calculateAge(data);
      this.dynFormGroup.controls['CurrentAge']?.patchValue(age);
    });

    const storedUserId = sessionStorage.getItem('userId');
    const storedAgencyId = sessionStorage.getItem('agencyId');

    if (storedUserId) {
      this.userId = storedUserId;
    }

    if (storedAgencyId) {
      this.agencyId = storedAgencyId;
      this.envMeckAgencyId = environment.agencyMecklenburg;
    }
  }

  ngAfterViewInit(): void {
    if (this.applicantId) {
      this.getApplicantData(Number(this.applicantId));
    }
  }

  getFormData() {
    this.isLoading = true;
    this.applicationFormService.getApplicationFormJson().subscribe(
      (data: any) => {
        this.formData = data.applicationFormAsJson;
        this.formLength = data.applicationFormAsJson?.form?.subforms?.length || 0; 
        //this.formData = JSONData;
        //this.formData = RockJSONData;
        //this.formLength = RockJSONData?.form?.subforms?.length || 0;
        this.formStyles = this.formData?.form?.formStyles || '';
        this.formJSON = JSON.parse(JSON.stringify(this.formData));
        if((this.isView)) {
          this.isReviewLoading = true;
          this.formData.form.subforms.forEach((subform:any,index:number)=>{
            if(subform.subform_name == 'Review Form') {
              this.reviewIndex = index;
            }
            if(subform.subform_name == 'Print') {
              this.printIndex = index;
            }
          });
          
          setTimeout(() => {
            for (let i = 0; i < this.reviewIndex; i++) {
              this.cdkStepper?.next();
            }
            const selectedIndex = this.cdkStepper?.selectedIndex;
            this.currentFormIndex = selectedIndex;
              this.subForm = this.formData.form.subforms[this.reviewIndex];
              if (this.subForm.subform_name == 'Review Form' && this.currentFormIndex == this.reviewIndex) {
                this.initializeReviewForm(true);
              }
              this.initializeForm();
              setTimeout(() => {
                this.getSubFormData();
              }, 100);
          }, 1000);
        }
        else {
          this.subForm = this.formData.form.subforms[0];
          this.reviewIndex = this.formData?.form?.subforms?.findIndex((subform: any) => subform?.subform_name === 'Review Form');
          this.printIndex = this.formData?.form?.subforms?.findIndex((subform: any) => subform?.subform_name === 'Print');
          this.initializeForm();
          this.currentFormIndex = 0;
          this.intializeFormJSON();
          if (this.applicationId) {
            setTimeout(() => {
              this.getSubFormData();
            }, 1000);
          }
          else {
            setTimeout(() => {
              this.populateFormFields(this.applicantDetails);
            }, 1500);
          }
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('There was an error fetching form data:', error);
        this.toastr.error('There was an error fetching form data. Please try again.');
        this.userManagementService.redirectToLogin(error,'');
      }
    );
  }

  intializeFormJSON() {
    this.formJSON?.form?.subforms?.map((subform: any) => {
      if (subform.subform_sections && subform.subform_sections.length) {
        subform?.subform_sections.map((section: any) => {
          section.fields.map((field: any) => {
            return (field.selected_values = []);
          });
        });
      }
    });
  }

  onPrevious() {
    this.subForm = {};
    this.cdkStepper.previous();
    const selectedIndex = this.cdkStepper.selectedIndex;
    this.currentFormIndex = selectedIndex;
    if(this.agencyId == environment.agencyMecklenburg) {
      if(this.currentFormIndex == this.printIndex) {
        this.saveButtonLabel = 'Submit';
      }
      else {
        this.saveButtonLabel = 'Next';
      }
    }
    else {
      if(this.currentFormIndex == this.reviewIndex) {
        this.saveButtonLabel = 'Submit';
      }
      else {
        this.saveButtonLabel = 'Next';
      }
    }
    this.subForm = JSON.parse(
      JSON.stringify(this.formData.form.subforms[this.currentFormIndex])
    );
    if (this.subForm.subform_id === 5) {
      this.isReviewLoading = false;
    }
    if (this.subForm.subform_name == 'Review Form' && this.currentFormIndex == this.reviewIndex) {
      this.initializeReviewForm(true);
    }
    this.initializeForm();
    setTimeout(() => {
      this.getSubFormData();
    }, 100);
  }
  printOptionSelected : string = '';
  getRating() {
    this.isLoading = true;
    this.applicationFormService
      .getSubFormFormData(this.applicationId)
      .subscribe((data: any) => {
          this.isLoading = false;
          if(data) {
            this.rating = data.ratings ? data.ratings : '';
            this.feedback = data.feedback ? data.feedback : '';
          }
        },
        (error) => {
          this.isLoading = false;
          console.error('There was an error fetching rating data:', error);
          this.toastr.error('There was an error fetching rating data. Please try again.');
        }
      );
  }
  giveRating(rating: any, feedback: any) {
    this.applicationFormService.updateRating(rating,feedback,this.applicationId).subscribe(
      (data) => {
      this.getRating();
      },
      (error)=> {
        console.error('There was an error updating rating data:', error);
        this.toastr.error('There was an error updating rating data. Please try again.');
      }
    );
  }
  
  /**
   * Validates all select (dropdown) controls in the dynamic form group to ensure required fields are filled.
   * Sets validation errors on controls that are required but not selected.
   *
   * @remarks
   * This function iterates over all controls in the dynamic form group and checks if the control is a dropdown
   * and is required. If so, it validates that a value is selected.
   *
   * @example
   * // Example fieldConfig structure:
   * // {
   * //   control_name: 'Gender',
   * //   control_type: 'dropdown',
   * //   validators: [{ type: 'required' }],
   * //   options: [{ key: 'M', value: 'Male' }, { key: 'F', value: 'Female' }]
   * // }
   *
   * @returns {boolean} True if all required select controls are valid, otherwise false.
   */
  validateAllSelectControls(): boolean {
  let isValid = true;
  Object.keys(this.dynFormGroup.controls).forEach(controlName => {
    const control = this.dynFormGroup.get(controlName);
    // Check if the control is a select (dropdown) by your naming or config convention
    // For example, if you know select controls have a certain suffix or are listed somewhere
    // Here, let's assume you want to check all controls of type 'dropdown'
    const fieldConfig = this.subForm?.subform_sections
      ?.flatMap((section: any) => section.fields)
      ?.find((field: any) => field.control_name === controlName);
    
    if (fieldConfig && fieldConfig.control_type === 'dropdown' && fieldConfig.validators?.some((v: IValidator) => v.type === 'required')) {
      if (
        control?.value === null ||
        control?.value === undefined ||
        control?.value === '' ||
        control?.value.includes('---Select---') ||
        (Array.isArray(control?.value) && control.value.length === 0)
      ) {
        control?.setErrors({ required: true });
        isValid = false;
      } else {
        control?.setErrors(null);
      }
    }
  });
    return isValid;
  }

  onNext(label?: any) {
    if(this.agencyId == environment.agencyMecklenburg && this.currentFormIndex == this.reviewIndex) {
      this.getRating();
    }
    if (this.currentFormIndex != this.reviewIndex && !this.isFormSubmitted) {
      if(this.agencyId == environment.agencyMecklenburg) {
        onNextSectionUtil(this, label);
      }
      else {
        if(this.dynFormGroup.invalid || !this.validateAllSelectControls()) {
          // Trigger change detection to update error messages
          if (this.formComponent) {
            this.formComponent.triggerChangeDetection();
          }
          this.toastr.error(`Please fill all the required fields`, '');
          this.dynFormGroup.markAllAsTouched();
        }
        else {
          this.onSubmit('', label);
        }
      }
    } else {
      if (label != 'saveDraft') {
        this.cdkStepper.next();
      }
      const selectedIndex = this.cdkStepper.selectedIndex;
      this.currentFormIndex = selectedIndex;
      if (this.currentFormIndex == this.formLength - 1) {
          this.isReviewLoading = false;
      }
      if(this.agencyId == environment.agencyMecklenburg) {
        if (this.printIndex > 0 && this.currentFormIndex == this.printIndex) {
          this.saveButtonLabel = 'Submit';
          this.isReviewLoading = false;
        }
        else {
          this.saveButtonLabel = 'Next';
        }
      }
      else {
        if(this.currentFormIndex == this.reviewIndex) {
          this.saveButtonLabel = 'Submit';
        }
        else {
          this.saveButtonLabel = 'Next';
        }
      }
      if (this.applicationId) {
        this.subForm = this.formData.form.subforms[this.currentFormIndex];
        if (this.subForm.subform_name == 'Review Form' && this.currentFormIndex == this.reviewIndex) {
          this.initializeReviewForm(true);
        }
        this.initializeForm();
        setTimeout(() => {
          this.getSubFormData();
        }, 100);
      } else {
        this.subForm = JSON.parse(
          JSON.stringify(this.formData.form.subforms[this.currentFormIndex])
        );
        if (this.subForm.subform_name == 'Review Form' && this.currentFormIndex == this.reviewIndex) {
          this.initializeReviewForm(true);
        }
        this.initializeForm();
      }
    }
  }

  validateNonMedicaidDate(label:any,fromDate: any,toDate: any) {
      validateNonMedicaidDateUtil(this.dynFormGroup, this.toastr, this.onSubmit.bind(this), label, fromDate, toDate);
  }
  validateMedicaidDate(label : any, fromDate: any, toDate : any) {
    validateMedicaidDateUtil(this.dynFormGroup, this.toastr, this.onSubmit.bind(this), label, fromDate, toDate);
  }

  initializeReviewForm(isDisable: boolean) {
    this.isReviewLoading = true;
    this.subForm.subform_sections = [];
    let previewIndex:any;
    this.formData.form?.subforms?.forEach((subform: any,index: number)=>{
      if(subform.subform_name == 'Review Form'){
        previewIndex = index;
      }
    });
    this.formData.form?.subforms?.forEach((section: any, index: any) => {
      if (index < previewIndex) {
        section.subform_sections?.forEach((field: any) => {
          if(this.subForm.subform_sections.indexOf(field) == -1 ) {
            this.subForm.subform_sections.push(JSON.parse(JSON.stringify(field)));
          }
        });
      }
    });
    this.subForm?.subform_sections?.forEach((field: any) => {
      field.fields?.forEach((control: any) => {
        if (control.control_type === 'checkbox') {
          control.options.forEach((option: any) => {
            option.isDisabled = true;
          });
        }
        control.is_disabled = isDisable;
      });
    });
  }
  createFormJSON() {
    this.formJSON?.form?.subforms[this.currentFormIndex]?.subform_sections?.map(
      (section: any) => {
        const fields = section?.fields?.map((field: any) => {
          const control = this.dynFormGroup.get(field.control_name);
          const value = control ? control.value : null;

          let selectedValues = [value];

          if (field.input_type === 'date' && value) {
            const selectedDate = formatDate(
              new Date(value),
              'yyyy-MM-dd',
              'en'
            );
            selectedValues = [DateTime.fromJSDate(new Date(value)).toUTC().toFormat('yyyy-MM-dd')];
          }
          if (field.control_type === 'dropdown' && value) {
            selectedValues = value;
          }
          field.selected_values = selectedValues;
        });
      }
    );
    const currentDate = new Date().toISOString();
    return {
      createdBy: this.userId,
      updatedBy: this.userId,
      createdDate: currentDate,
      updatedDate: currentDate,
      applicantId: Number(this.applicantId),
      userId: this.userId,
      agencyId: this.agencyId,
      applicationId: this.applicationId,
      applicationUiForm: {
      name: 'Applicant Form',
      version: 1,
      subforms: this.formJSON?.form?.subforms,
      'Created By': 'Default User',//ask priyank
      'Created Timestamp': currentDate,
      'Updated By': 'Default User',//ask priyank
      'Updated Timestamp': null,
      },
      completionStatus:
      this.currentFormIndex + 1 === this.formData?.form?.subforms?.length, // true when on submit
      active: true,
    };
  }

  gotoProfile() {
    this.router.navigate(['/applicant-detail']);
  }
  // 2.
  setFundingSourcesInFormData(mData: any) {
    // mData is 2D array
    let fundingSourceData = mData;
    this.disabledIndexes?.forEach((disabledFundingSource: any)=> {
      // insert the disabled funding source option at the index where it was disabled
      fundingSourceData?.splice(disabledFundingSource.index, 0, disabledFundingSource.isSelected);
    });
    this.finalSelectedValues[0] = fundingSourceData;
    let subformIndex = this.formData?.form?.subforms[3]?.subform_sections?.findIndex((subForm: any)=>subForm.section_name === 'Funding Sources');
    // set selected values from this.finalSelectedValues array in this.formData
    this.formData.form.subforms[3].subform_sections[subformIndex].fields[0].selected_values = this.finalSelectedValues;
    this.formData.form.subforms[3].subform_sections[subformIndex].fields[0].options?.forEach((option: any,index: number)=> {
      option.isSelected = fundingSourceData[index];
    });
    // set options array from this.formData in this.finalFundingSourceList
    this.finalFundingSourceList = this.formData?.form?.subforms[3]?.subform_sections[subformIndex]?.fields[0]?.options;
  }
  // 3.
  getFundingSourceFromFormForSavedOrNewApplication(jsonPayload: any) {
    let subformIndex = this.formData.form.subforms[3].subform_sections.findIndex((subForm: any)=>subForm.section_name === 'Funding Sources');
    jsonPayload.applicationUiForm.subforms[3].subform_sections[subformIndex].fields[0].options = this.finalFundingSourceList;
    jsonPayload.applicationUiForm.subforms[3].subform_sections[subformIndex].fields[0].selected_values = this.finalSelectedValues;
  }
  // 4.
  getFundingSourceFromFormForSubmittedApplication() {
    let subformIndex = this.formData.form.subforms[3].subform_sections?.findIndex((subForm: any)=>subForm.section_name === 'Funding Sources');
    this.disabledIndexes = [];
    let selectedValues: any[][] = [[]];
    this.formData?.form?.subforms[3]?.subform_sections[subformIndex]?.fields[0]?.options.forEach((option:any,index:number)=>{
      if(option.isDisabled) {
        this.disabledIndexes?.push({index:index, isSelected:option.isSelected});
      }
      selectedValues[0]?.push(option.isSelected);
    });
    this.formData.form.subforms[3].subform_sections[subformIndex].fields[0].selected_values = selectedValues;
  }
  // 1.
  setFundingSourceFromApiResponse(response: any, subformIndex: any) {
    // set funding source options in form data from the response funding source options
    this.formData.form.subforms[3].subform_sections[subformIndex].fields[0].options = response?.applicationUiFormAsJson?.subforms[3]?.subform_sections[subformIndex]?.fields[0]?.options;
    this.disabledIndexes = [];
    let selectedValues: any[][] = [[]];
    //eg. options:  [{key: 'Medicaid', value: 'Medicaid', isSelected: false, isDisabled: false},{key: 'ARPA', value: 'ARPA', isSelected: false, isDisabled: false}]
    this.formData?.form?.subforms[3]?.subform_sections[subformIndex]?.fields[0]?.options?.forEach((option: any,index: number)=> {
      if(option?.isDisabled) {
        // push the index of the disabled funding source option in this.disabledIndexes array
        this.disabledIndexes?.push({ index:index, isSelected:option.isSelected });
      }
      selectedValues[0]?.push(option.isSelected);
    });
    // set the selected values in this.formData
    this.formData.form.subforms[3].subform_sections[subformIndex].fields[0].selected_values = selectedValues;
    // eg. selected_values : [[false,false,true,true,false,false,false,false,false,true,false,false]]  ...here true means selected of disabled array and false means not selected
  }
  saveDataAndGotoNextStep(
    jsonPayload: any,
    storedApplicationId: any,
    param: string,
    label?: any
  ) {
    if (param === 'submit') {
      this.isDeterminationLoading = true;
    } else {
      this.isLoading = true;
    }
    this.subForm = {};
    if(this.agencyId == environment.agencyMecklenburg) {
      jsonPayload.enableFundingSources = {};
      jsonPayload.enableFundingSources = false;
      if(this.currentFormIndex == 2) {
        jsonPayload.enableFundingSources = true;
      }
      if(this.currentFormIndex == 3 || this.currentFormIndex == 4) {
        // set funding source options & selected_values in jsonpayload from this.formData funding source options & selected_values for saved/new application
        this.getFundingSourceFromFormForSavedOrNewApplication(jsonPayload);
      }
      if(this.currentFormIndex == 3 && this.isFormSubmitted) {
        // set funding source options & selected_values in jsonpayload from this.formData funding source options & selected_values for submitted/terminated application
        this.getFundingSourceFromFormForSubmittedApplication();
      }
    }
    if(this.agencyId != environment.agencyMecklenburg) {
      this.userService.parentApplicationId$.subscribe((parentAppId) => {
        if(parentAppId!=-1) {
          jsonPayload.parentApplicationId = parentAppId;
          jsonPayload.applicationId = null;
          this.applicationId = null;
          this.userService.clearParentApplicationId();
          console.log(jsonPayload);
        }
      });
    }
    this.applicationFormService.submitPayload(jsonPayload).subscribe(
      (response) => {
        if(response) {
          if(this.agencyId == environment.agencyMecklenburg && this.currentFormIndex == 2) {
            let subformIndex = this.formData.form?.subforms[3]?.subform_sections?.findIndex((subForm:any)=>subForm?.section_name === 'Funding Sources');
            this.formData.form.subforms[3].subform_sections[subformIndex].fields[0].selected_values = [[]];
            this.setFundingSourceFromApiResponse(response, subformIndex);
          }
          this.isLoading = false;
          this.showModal = false;
          this.applicationId = response?.applicationId;
          // Update the route parameter to the new applicationId
          if (this.applicationId) {
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: { id: this.applicationId },
              queryParamsHandling: 'merge',
              replaceUrl: true
            });
          }
          if (param === 'submit') {
            this.isDeterminationLoading = false;
            if(this.agencyId == environment.agencyMecklenburg) {
              this.openDialog('rating');
            }
            this.toastr.success(
              `Form data submitted successfully! Application ID is: ${this.applicationId}`,
              '',
              { timeOut: 2000 }
            );
          }
          if (storedApplicationId && param != 'submit') {
          this.isLoading = false;
            this.toastr.success(
              `Form data saved successfully! Application ID is: ${this.applicationId}`,
              '',
              { timeOut: 1000 }
            );
          }
          if (jsonPayload.completionStatus == true) {
            this.isFormSubmitted = true;
            this.saveButtonLabel = 'Next';
          }
          if (label != 'saveDraft') {
            this.cdkStepper.next();
          }
          const selectedIndex = this.cdkStepper.selectedIndex;
          this.currentFormIndex = selectedIndex;
          if (
            this.currentFormIndex === this.formLength - 1 && !this.isFormSubmitted
          ) {
            this.saveButtonLabel = 'Submit';
          } else {
            this.saveButtonLabel = 'Next';
          }
          if (this.applicationId) {
            this.isLoading = false;
            this.subForm = JSON.parse(
              JSON.stringify(this.formData.form.subforms[this.currentFormIndex])
            );
            if (this.subForm.subform_name === 'Review Form' && this.currentFormIndex === this.reviewIndex) {
              this.isLoading = false;
              this.initializeReviewForm(true);
            }
            this.initializeForm();
            setTimeout(() => {
              this.getSubFormData();
            }, 100);
          } else {
            this.subForm = JSON.parse(
              JSON.stringify(this.formData.form.subforms[this.currentFormIndex])
            );
            if (this.subForm.subform_name === 'Review Form' && this.currentFormIndex === this.reviewIndex) {
              this.initializeReviewForm(true);
            }
            this.initializeForm();
          }
        }
      },
      (error) => {
        if (param === 'submit') {
          this.isDeterminationLoading = false;
        } else {
          this.isLoading = false;
        }
        this.showModal = false;
        console.error('There was an error saving sub-form data:', error);
        this.toastr.error('There was an error saving sub-form data. Please try again.');
        this.userManagementService.redirectToLogin(error,'');
      }
    );
  }
  onSubmit(param: any, label?: any) {
    const jsonPayload = this.createFormJSON();
    const storedApplicationId = localStorage.getItem('applicationId');

    if (storedApplicationId) {
      // If applicationId exists, add it to payload
      jsonPayload.applicationId = parseInt(storedApplicationId, 10);
    }
    if (this.saveButtonLabel === 'Submit') {
      this.showModal = true;
      if (param && param === 'submit') {
        this.saveDataAndGotoNextStep(
          jsonPayload,
          storedApplicationId,
          param,
          label
        );
      }
    } else {
      this.isLoading = true;
      this.showModal = false;
      this.saveDataAndGotoNextStep(
        jsonPayload,
        storedApplicationId,
        param,
        label
      );
    }
  }
  responseData: any;
  // Fetches are deferred via setTimeout; skip any that fire after destroy.
  private destroyed = false;
  getSubFormData() {
    if (this.destroyed) {
      return;
    }
    this.applicationFormService
      .getSubFormFormData(this.applicationId)
      .subscribe((data: any) => {
        if (data) {
          this.responseData = data;
          this.userService.parentApplicationId$.subscribe((parentAppId) => {
              if(parentAppId!=-1) {
                this.renewalParentId = parentAppId;
              }
          });
          if(this.isEligibilityAutoDetermined) {
            this.renewalParentId = -1;
          }
          // If completion status is 1(Submitted),2(Terminated),3(Terminated) and renewalParentId is -1, set isFormSubmitted to true
          if (this.applicationId) {
            if ((data.completionStatus == 1 || data.completionStatus == 2 || data.completionStatus == 3) && this.renewalParentId == -1) {
              this.isFormSubmitted = true;
              if(this.agencyId == environment.agencyMecklenburg && this.currentFormIndex == 4) {
                let subformIndex = this.formData?.form?.subforms[3]?.subform_sections?.findIndex((subForm:any)=>subForm.section_name === 'Funding Sources');
                this.formData.form.subforms[3].subform_sections[subformIndex].fields[0].options = data.applicationUiFormAsJson.subforms[3].subform_sections[subformIndex].fields[0].options;
              }
            }
            let JSONData = data.applicationUiFormAsJson;
            this.formJSON.form = JSON.parse(JSON.stringify(JSONData));
            setTimeout(() => {
              this.setFormValue(data.applicationUiFormAsJson);
            }, 100);
          } else {
            if (this.dynFormGroup.controls['sameAsHomeAddress']?.value) {
              this.patchMailingAddress();
            }
            if (data.completionStatus == 1 || data.completionStatus == 2 || data.completionStatus == 3) {
              this.isFormSubmitted = true;
            }
            setTimeout(() => {
              this.setFormValue(data.applicationUiFormAsJson);
            }, 100);
          }
        }
      },
      (error) => {
        console.error('There was an error fetching sub-form data:', error);
        this.toastr.error('There was an error fetching sub-form data. Please try again.');
        this.userManagementService.redirectToLogin(error,'');
      });
  }
  applicantDetails: any;
  getApplicantData(applicantId: number) {
    this.isLoading = true;
    this.applicantService.fetchApplicantDetails(applicantId).subscribe(
        (data: any) => {
          this.isLoading = false;
          if (data) {
            const applicantDetails = data.applicantDetailsAsJson;
            this.applicantDetails = applicantDetails;
            this.populateFormFields(applicantDetails);
          }
        },
        (error) => {
          this.isLoading = false;
          console.error('There was an error fetching applicant data:', error);
          this.toastr.error('There was an error fetching applicant data. Please try again.');
        }
      );
  }
  disabledIndexes: any[] = [];

  formatPhoneNumber(phoneNo: any) {
    return [phoneNo?.slice(0, 3), "-", phoneNo?.slice(3,6), "-", phoneNo?.slice(6)].join('');
  }
  setPhoneNumber(controlName: string, phoneValue: string | undefined, formatFn: (v: string) => string) {
    if (!phoneValue) {
      this.dynFormGroup.controls[controlName]?.setValue('');
    } else if (phoneValue !== '' && !phoneValue.includes('-')) {
      this.dynFormGroup.controls[controlName]?.setValue(formatFn(phoneValue));
    } else {
      this.dynFormGroup.controls[controlName]?.setValue(phoneValue);
    }
  }
  populateFormFields(applicantDetails: any) {
    this.dynFormGroup.controls['FirstName']?.setValue(applicantDetails.first_name || '');
    this.dynFormGroup.controls['MiddleName']?.setValue(applicantDetails.middle_name_initials || '');
    this.dynFormGroup.controls['LastName']?.setValue(applicantDetails.last_name || '');
    this.dynFormGroup.controls['DateOfBirth']?.setValue(applicantDetails?.date_of_birth || '');
    this.dynFormGroup.controls['CurrentAge']?.setValue(this.calculateAge(applicantDetails.date_of_birth));
    this.dynFormGroup.controls['Gender']?.patchValue([applicantDetails.gender]);
    this.dynFormGroup.controls['EmergencyName']?.setValue(applicantDetails?.emergency_contact);

    if (this.agencyId == environment.agencyMecklenburg) {
      this.setPhoneNumber('ContactPrimaryPhoneNumber', applicantDetails?.extra7, this.formatPhoneNumber.bind(this));
      this.setPhoneNumber('ContactAlternatePhoneNumber', applicantDetails?.phone_mobile, this.formatPhoneNumber.bind(this));
      if (applicantDetails?.phone_mobile) {
        this.populateAlternatePhoneNumberType();
      }
    } else {
      this.setPhoneNumber('ContactPrimaryPhoneNumber', applicantDetails?.phone_landline, this.formatPhoneNumber.bind(this));
      this.setPhoneNumber('ContactAlternatePhoneNumber', applicantDetails?.phone_mobile, this.formatPhoneNumber.bind(this));
      if (applicantDetails?.phone_mobile) {
        this.populateAlternatePhoneNumberType();
      }
    }
    if (applicantDetails?.emergency_phone_day && !applicantDetails?.emergency_phone_day.includes('-')) {
      this.dynFormGroup.controls['EmergencyPrimaryPhoneNumber']?.setValue(this.formatPhoneNumber(applicantDetails.emergency_phone_day));
    } else {
      this.dynFormGroup.controls['EmergencyPrimaryPhoneNumber']?.setValue(applicantDetails?.emergency_phone_day || '');
    }

    if ((applicantDetails?.emergency_phone_day != '') && !(applicantDetails?.emergency_phone_day?.includes('-'))) {
      this.dynFormGroup.controls['EmergencyPrimaryPhoneNumber']?.setValue(this.formatPhoneNumber(applicantDetails.emergency_phone_day));
    } else {
      this.dynFormGroup.controls['EmergencyPrimaryPhoneNumber']?.setValue(applicantDetails?.emergency_phone_day ? applicantDetails.emergency_phone_day : '');
    }
    this.dynFormGroup.controls['ContactEmailAddress']?.setValue(applicantDetails?.email || '');
    
    let homeAddress = '';
    if (applicantDetails?.home_street_number) {
      homeAddress = applicantDetails.home_street_number + ' ';
    }
    homeAddress += applicantDetails?.home_street ? applicantDetails.home_street : '';
    this.dynFormGroup.controls['HomeAddress']?.setValue(homeAddress);
    this.dynFormGroup.controls['HomeCity']?.setValue(applicantDetails?.home_city || '');
    this.dynFormGroup.controls['HomeState']?.setValue([applicantDetails?.home_state]);
    this.dynFormGroup.controls['HomeZipCode']?.setValue(applicantDetails?.home_postcode || '');

    this.dynFormGroup.controls['emergency_address']?.setValue(applicantDetails?.emergency_address || '');
    this.dynFormGroup.controls['emergency_city']?.setValue(applicantDetails?.emergency_city || '');
    this.dynFormGroup.controls['emergency_state']?.setValue(applicantDetails?.emergency_state ? [applicantDetails.emergency_state] : []);
    this.dynFormGroup.controls['emergency_postcode']?.setValue(applicantDetails?.emergency_postcode || '');
    this.dynFormGroup.controls['extra3']?.setValue(applicantDetails?.extra3 ? [applicantDetails.extra3] : []);
    this.dynFormGroup.controls['extra4']?.setValue(applicantDetails?.extra4 ? [applicantDetails.extra4] : []);

    if(this.agencyId == environment.agencyMecklenburg) {
      populateFormFieldsUtil(this.dynFormGroup, applicantDetails);
    }
    this.isLoading = false;
    this.dataCompleted = true;
  }

  populateAlternatePhoneNumberType() {
    const contactAlternatePhoneNumber = this.dynFormGroup.get('ContactAlternatePhoneNumber')?.value;
      if (contactAlternatePhoneNumber) {
        setTimeout(() => {
          this.dynFormGroup.controls['ContactAlternateType']?.setValue(["Cell"]);
        }, 500);
      }
  }
  setNonMedicaidDates() {
    setNonMedicaidDatesUtil(this.dynFormGroup, this);
  }
  setFormValue(applicationFormSavedData: any) {
    if (this.currentFormIndex == this.reviewIndex) {
      applicationFormSavedData.subforms[
        this.currentFormIndex
      ].subform_sections = [];
      applicationFormSavedData?.subforms.forEach((section: any) => {
        section?.subform_sections?.forEach((field: any) => {
          applicationFormSavedData?.subforms[
            this.currentFormIndex
          ].subform_sections.push(field);
        });
      });
    }
    for (let control in this.dynFormGroup.controls) {
      applicationFormSavedData?.subforms[
        this.currentFormIndex
      ]?.subform_sections?.forEach((subsection: any) => {
        subsection?.fields?.forEach((field: any) => {
          if (field.control_name === control) {
            if (field.control_type === 'dropdown') {
              this.dynFormGroup?.controls[control]?.patchValue(
                field.selected_values
              );
            } 
            else {
             if((this.currentFormIndex == 4) && (this.responseData) && (this.responseData?.historical) && (this.responseData?.completionStatus == 1 || this.responseData?.completionStatus == 2 || this.responseData?.completionStatus == 3)) {
              if(field?.selected_values == null) {
                this.dynFormGroup?.controls[control]?.patchValue(
                  [null]
                );
               }
               else {
                this.dynFormGroup?.controls[control]?.patchValue(
                  field.selected_values ? field.selected_values[0] : ''
                );
               }
             }
             else {
              this.dynFormGroup?.controls[control]?.patchValue(
                field.selected_values ? field.selected_values[0] : ''
              );
             }
            }
          }
        });
      });
    }
    let subformIndex = this.formData?.form?.subforms[3]?.subform_sections?.findIndex((subForm:any)=>subForm.section_name === 'Funding Sources');
    if(this.agencyId == environment.agencyMecklenburg && this.currentFormIndex == 3 && !this.isFormSubmitted) {
      this.dynFormGroup.controls['fundingSource']?.setValue(this.formData?.form?.subforms[3]?.subform_sections[subformIndex]?.fields[0]?.selected_values[0]);
      this.setNonMedicaidDates();
    }
    if(this.currentFormIndex == this.reviewIndex) {
      this.isReviewLoading = false;
      this.createdBy = this.responseData?.createdName;
      this.lastModifiedBy = this.responseData?.updatedName;
      this.lastModifiedDate = this.responseData?.updatedDate ? DateTime.fromJSDate(new Date(this.responseData?.updatedDate)).toLocal().toFormat('yyyy-MM-dd'): '';
      this.createdDate = this.responseData?.createdDate ? DateTime.fromJSDate(new Date(this.responseData?.createdDate)).toLocal().toFormat('yyyy-MM-dd') : '';
      if(!this.dynFormGroup.controls['fromNonMedicaidDate']?.value) {
        this.dynFormGroup.controls['fromNonMedicaidDate']?.setValue(this.fromNonMedicaidDate);
      }
      if(!this.dynFormGroup.controls['toNonMedicaidDate']?.value) {
        this.dynFormGroup.controls['toNonMedicaidDate']?.setValue(this.toNonMedicaidDate);
      }
      this.dynFormGroup.controls['createdBy']?.setValue(this.createdBy);
      this.dynFormGroup.controls['dateCreated']?.setValue(this.createdDate);
      this.dynFormGroup.controls['modifiedBy']?.setValue(this.lastModifiedBy);
      this.dynFormGroup.controls['dateModified']?.setValue(this.lastModifiedDate); 
    }
    if((this.currentFormIndex === 4) && (this.responseData) && (this.responseData?.completionStatus == 1 || this.responseData?.completionStatus == 2 || this.responseData?.completionStatus == 3) && !(this.goToReview)) {
      this.onPrevious();
      this.onNext();
      this.goToReview = true;
    }
    if(this.dynFormGroup.get('medicaid')?.value === '') {
      this.dynFormGroup.controls['isApplicantEligibleForMedicaid?']?.disable();
    }
    this.isLoading = false;
    this.dataCompleted = true;
  }
  finalFundingSourceList : any[] = [];
  finalSelectedValues : any[][] = [[]];
  enableFromToDates : any[] = [];

  initializeForm(): void {
    const fbGroup = this.formBuilder.group({});
    this.dynFormGroup = fbGroup;

    this.subForm?.subform_sections?.forEach((subsection: any) => {
      subsection?.fields?.forEach((field: any) => {
        if (
          field.control_type == 'checkbox' &&
          field.options &&
          field.options.length
        ) {
          fbGroup.addControl(
            field.control_name,
            this.formBuilder.array(this.buildCheckBox(field))
          );
          const formBuilderArr = fbGroup.get(field.control_name) as FormArray;
          if(field?.validators && field.validators.some((v: any) => v.type === 'required')) {
            formBuilderArr.setValidators([this.minSelectedCheckboxes(1)]);
          }
          formBuilderArr.valueChanges.subscribe(val => {
            const atLeastOneSelected = val.some((selected: any) => selected === true);
            if (field?.validators && field.validators.some((v: any) => v.type === 'required')) {
              if (!atLeastOneSelected) {
                formBuilderArr.setErrors({ required: true });
              } else {
                formBuilderArr.setErrors(null);
              }
            }
          });
        } else {
          fbGroup.addControl(
            field.control_name,
            new FormControl(
              {
                value:
                  field.default_value !== '' && field.default_value !== null
                    ? field.default_value
                    : '',
                disabled: field.is_disabled,
              },
              field.validators && field.validators.length
                ? this.bindValidators(field?.validators)
                : []
            )
          );
        }
      });
    });
    this.dynFormGroup = fbGroup;
    if(this.agencyId == environment.agencyMecklenburg) {
      registerDateAndAddressValueChangeHandlers(this.dynFormGroup, this);
    }

    if (this.agencyId == environment.agencyMecklenburg && this.subForm.subform_id != 6) {
      registerValueChangeHandlers(this.dynFormGroup, this.isFormSubmitted, this.setFundingSourcesInFormData.bind(this));
    }
  }
  minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: AbstractControl) => {
      const totalSelected = (formArray as FormArray).controls
        .map((control) => control.value)
        .reduce((prev, next) => (next ? prev + 1 : prev), 0);
      return totalSelected >= min ? null : { required: true };
    };
    return validator;
  }
  patchMailingAddress() {
    this.dynFormGroup.controls['MailingAddress']?.patchValue(
      this.dynFormGroup.controls['HomeAddress'].value
    );
    this.dynFormGroup.controls['MailingCity']?.patchValue(
      this.dynFormGroup.controls['HomeCity'].value
    );
    this.dynFormGroup.controls['MailingState']?.patchValue(
      this.dynFormGroup.controls['HomeState'].value
    );
    this.dynFormGroup.controls['MailingZipCode']?.patchValue(
      this.dynFormGroup.controls['HomeZipCode'].value
    );
  }

  buildCheckBox(field: any) {
    let selectedOption: any = [];
    field.options.forEach((option: any) => {
      let value = option.isSelected;
      selectedOption.push(
        new FormControl({ value, disabled: option.isDisabled })
      );
    });
    return selectedOption;
  }

  bindValidators(validator: IValidator[]) {
    if (!validator || validator.length <= 0) return [];
    else {
      const validatorList: any = [];
      validator.forEach((el) => {
        validatorList.push(this.getValidation(el.type, el.value));
      });
      return Validators.compose(validatorList);
    }
  }

  getValidation(type: any, value: any) {
    switch (type) {
      case 'required':
        return Validators.required;
      case 'minlength':
        return Validators.minLength(value);
      case 'maxlength':
        return Validators.maxLength(value);
      case 'email':
        return Validators.email;
      default:
        return;
    }
  }

  calculateAge(birthday: any): number | '' {
    return calculateAge(birthday);
  }

  ngOnDestroy() {
    this.destroyed = true;
  }
  readonly dialog = inject(MatDialog);
  openDialog(dialogName: string) {
    const dialogRef = this.dialog.open(EgDialogComponent,
      {
        data: {
          param : dialogName,
          header: 'Your opinion matters to us!',
          content: [
            'On a scale of 1-10, how likely are you to recommend',
            ' Mecklenburg Transportation System to a friend or',
            ' family member?'
          ],
          actions: ['Submit', 'Cancel']
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.giveRating(result.data.rating , result.data.feedback);
      }
    });
  }
}
